module.exports = __webpack_public_path__ + "img/ypbd.9bf7f846.gif";